module.exports = __webpack_public_path__ + "img/banner-edu-text.3fb46928.png";